import svgIcons from '@/assets/svg/icons';
import SvgIcon from '@/components/atoms/SvgIcon';
import colors from '@/theme/colors';
import React from 'react';
import Switch from 'react-switch';

interface Props {
  name?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const PeerSupportSwitch = ({ name, checked, onChange }: Props) => {
  return (
    <Switch
      name={name}
      checked={checked}
      onChange={onChange}
      handleDiameter={18}
      offColor={colors.extra.red20pct}
      onColor={colors.extra.teal20pct}
      offHandleColor={colors.extra.red}
      onHandleColor={colors.extra.teal}
      height={27}
      width={45}
      borderRadius={20}
      uncheckedHandleIcon={
        <SvgIcon
          iconPath={svgIcons.closeSmall}
          color="#fff"
          size={12}
          boxHeight={14}
          boxWidth={14}
          style={{ marginLeft: 2, marginTop: 2 }}
        />
      }
      checkedHandleIcon={
        <SvgIcon
          iconPath={svgIcons.checkSmall}
          color="#fff"
          size={14}
          boxHeight={10}
          boxWidth={10}
          style={{ marginLeft: 3, marginTop: 5 }}
        />
      }
      checkedIcon={<></>}
      uncheckedIcon={<></>}
      className="react-switch"
      id="small-radius-switch"
    />
  );
};

export default PeerSupportSwitch;
